import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LineChart, ChartType, HorizontalBarChart, PieChart } from 'Shared/app/models/chart';
import {
  BarChartResult,
  ChartResult,
  HorizontalBarChartResult,
  LineChartResult,
  PieChartResult
} from 'Shared/app/models/formResult';
import { of } from 'rxjs';

@Injectable()
export class StaticFormChartTranslationService {
  getTranslations(chart: ChartResult, translationService: TranslateService) {
    const texts = [];
    texts.push(chart.chart.title);
    texts.push(chart.chart.subTitle);
    if (chart.chart.labels) {
      texts.push(...chart.chart.labels);
    }
    texts.push(chart.chart.xAxeTitle);
    texts.push(chart.chart.yAxeTitle);
    if (chart.chart.type === ChartType.BarChart) {
      if ((chart as BarChartResult).labels) {
        texts.push(...(chart as BarChartResult).labels);
      }
    } else if (chart.chart.type === ChartType.LineChart) {
      if ((chart as LineChartResult).series) {
        texts.push(...(chart as LineChartResult).series);
      }
      if ((chart.chart as LineChart).series) {
        texts.push(...(chart.chart as LineChart).series);
      }
    } else if (chart.chart.type === ChartType.HorizontalBarChart) {
      if ((chart as HorizontalBarChartResult).labels) {
        texts.push(...(chart as HorizontalBarChartResult).labels);
      }
      if ((chart.chart as HorizontalBarChart).series) {
        texts.push(...(chart.chart as HorizontalBarChart).series);
      }
    } else if (chart.chart.type === ChartType.PieChart) {
      if ((chart as PieChartResult).labels) {
        texts.push(...(chart as PieChartResult).labels);
      }
    }
    for (const highlight of chart.chart.highlights) {
      texts.push(highlight.title);
    }
    if (texts.filter((t) => !!t).length === 0) {
      return of({});
    }
    return translationService.get(texts.filter((t) => !!t));
  }

  updateChartTexts(chart: ChartResult, translations: any): void {
    chart.chart.title = translations[chart.chart.title];
    chart.chart.subTitle = translations[chart.chart.subTitle];
    if (chart.chart.labels) {
      chart.chart.labels = chart.chart.labels.map((l) => translations[l]);
    }
    chart.chart.xAxeTitle = translations[chart.chart.xAxeTitle];
    chart.chart.yAxeTitle = translations[chart.chart.yAxeTitle];
    for (const highlight of chart.chart.highlights) {
      highlight.title = translations[highlight.title];
    }
    if (chart.chart.type === ChartType.BarChart) {
      if ((chart as BarChartResult).labels) {
        (chart as BarChartResult).labels = (chart as BarChartResult).labels.map((l) => translations[l]);
      }
    } else if (chart.chart.type === ChartType.LineChart) {
      if ((chart as LineChartResult).series) {
        (chart as LineChartResult).series = (chart as LineChartResult).series.map((l) => translations[l]);
      }
      if ((chart.chart as any).series) {
        (chart.chart as any).series = (chart.chart as any).series.map((l) => translations[l]);
      }
    } else if (chart.chart.type === ChartType.HorizontalBarChart) {
      if ((chart as HorizontalBarChartResult).labels) {
        (chart as HorizontalBarChartResult).labels = (chart as HorizontalBarChartResult).labels.map(
          (l) => translations[l]
        );
      }
      if ((chart.chart as HorizontalBarChart).series) {
        (chart.chart as HorizontalBarChart).series = (chart.chart as HorizontalBarChart).series.map(
          (l) => translations[l]
        );
      }
    } else if (chart.chart.type === ChartType.PieChart) {
      if ((chart as PieChartResult).labels) {
        (chart as PieChartResult).labels = (chart as PieChartResult).labels.map((l) => translations[l]);
      }
      if ((chart.chart as PieChart).labels) {
        (chart.chart as PieChart).labels = (chart.chart as PieChart).labels.map((l) => translations[l]);
      }
    }
  }
}
